export function btnmatrix(ctx) {
    return {
        styles: {
            main: { ...ctx.pretty, radius: 5, padding: 0 },
            // item_buttons part — uses btn style
            item_buttons: {
                bg_color:     ctx.btnBg,
                border_color: ctx.btnBorder,
                border_width: 2,
                text_color:   ctx.TEXT_DEFAULT,
                text_font:    32,
                radius:       5,
            },
        },
    };
}
